var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.67403 15.8949C13.1675 15.8949 15.9994 13.0629 15.9994 9.56948C15.9994 6.07606 13.1675 3.24408 9.67403 3.24408C6.18061 3.24408 3.34863 6.07606 3.34863 9.56948C3.34863 13.0629 6.18061 15.8949 9.67403 15.8949Z",
    stroke: "url(#paint0_linear_188_2166)",
    strokeWidth: 2.37202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5801 17.4762L14.1406 14.0367",
    stroke: "url(#paint1_linear_188_2166)",
    strokeWidth: 2.37202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_2166",
    x1: 3.02778,
    y1: 2.49159,
    x2: 15.334,
    y2: 16.5151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4B7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_188_2166",
    x1: 14.0534,
    y1: 13.8322,
    x2: 17.3991,
    y2: 17.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4B7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesSearch);
export default __webpack_public_path__ + "static/media/devices-search.4839ba1dc47164154f589985750ebca4.svg";
export { ForwardRef as ReactComponent };